export enum GiftCardDiscountType {
  AddAmount,
  AddPercent,
  DiscountAmount,
  DiscountPercent,
}
